import { createMachine, assign } from 'xstate';
import { loyaltyGuestClaim } from '../requests/loyalty-guest-claim';

const populateMessage = assign({
  data: (_, payload: any) => {
    const message = payload?.message;
    const error = message?.message;
    const data = payload?.data;

    if (data) {
      logger.debug(`api - loyaltyGuestClaim - FSM data recieved:`, data);
      return data;
    }

    if (error) {
      logger.error(`api - loyaltyGuestClaim - FSM error recieved:`, error);
      return error;
    }

    logger.error(`api - loyaltyGuestClaim - FSM message recieved:`, message);
    return message;
  },
});

const createloyaltyGuestClaimMachine = ({
  kioskSerialKey = '',
  storeId = '',
  organisationId = '',
  sessionId = '',
  cart = null,
} = {}) =>
  createMachine<{
    kioskSerialKey: string;
    storeId: string;
    organisationId: string;
    sessionId: string;
    cart: any;
  }>(
    {
      id: 'loyaltyGuestClaim',
      initial: 'processing',
      context: {
        kioskSerialKey,
        storeId,
        organisationId,
        sessionId,
        cart,
      },
      states: {
        processing: {
          invoke: {
            src: ({ kioskSerialKey, storeId, organisationId, sessionId, cart }) =>
              loyaltyGuestClaim({ kioskSerialKey, storeId, organisationId, sessionId, cart }),
            onDone: {
              target: 'success',
              actions: ['populateMessage'],
            },
            onError: {
              target: 'error',
              actions: ['populateMessage'],
            },
          },
        },
        success: {
          on: {
            IDLE: 'processing',
          },
        },
        error: { type: 'final' },
      },
    },
    {
      actions: {
        populateMessage,
      },
    },
  );

export { createloyaltyGuestClaimMachine };
